// JavaScript code for acf_blocks/events-calendar-list component
(($) => {

     "use strict";
     if ($('.acf-blocks-events-calendar-list').length === 0) {
          return;
     }
     console.log("acf_blocks/events-calendar-list scripts loaded...");

     $('.acf-blocks-events-calendar-list .filter-by-year .input-year').on('change', function() {
          $(this).closest('form').submit();
     });

})(jQuery);